import { en } from './en'
import { fr } from './fr'

export const marketplacePage = {
  en,
  fr
}